module.exports = __webpack_public_path__ + "img/about-us-leader.2483436c.jpg";